import { Dispatcher } from 'flux';
import { ActionTypes } from '../constants/CentricConstants';
import assign from 'object-assign';
import { normalize } from 'normalizr';

const DEBUG = (process.env.NODE_ENV === 'development');

class CentricDispatcher extends Dispatcher {

    throttleDispatch(parameters) {
        if (this.isDispatching) {
            setTimeout(() => this.dispatch(parameters), 1);
        } else {
            this.dispatch(parameters);
        }
    }

    dispatchPayload(type, payload) {
        this.throttleDispatch({ type, payload: assign({}, payload) });
    }

    dispatchAsync(promise, types, payload, schema) {
        const { request, success, failure } = types;
        const exception = (types.exception || ActionTypes.API_EXCEPTION );
        const successArray = (Array.isArray(success) ? success : [success]);
        const failureArray = (Array.isArray(failure) ? failure : [failure]);
        if (!!request ) {
            this.throttleDispatch({ type: request, payload: assign({}, payload) });
        }
        return promise.then(
            response => {
                const data = schema ? normalize(response.data, schema) : response.data;
                successArray.forEach( type => !!type && this.dispatch({ type, data, payload: assign({}, payload) }), this );
            },
            error => failureArray.forEach( type => !!type && this.dispatch({ type, data: (error.message || 'Internal error'), code: error.code, payload: assign({}, payload) }), this)
        )
        .catch(
            error => this.dispatch({ type: exception, data: error.message, codes: error.code, payload: assign({}, payload) })
        );
    }
}

class CentricDebugDispatcher extends CentricDispatcher {
    // debug catchall, should not be committed (but protected for accidental commits)
    dispatch({type, payload, data, error}) {
        console.group(`DISPATCH: ${type}`);
        if (payload !== undefined) { console.info('%c payload:', 'color: blue', payload); }
        if (!!data) { console.info('%c data:', 'color: green', data); }
        if (!!error) { console.error('%c error:', 'color: red', error); }
        console.groupEnd();
        super.dispatch(...arguments);
    }
}

const dispatcher = (DEBUG && !!console) ? new CentricDebugDispatcher() : new CentricDispatcher();
export default dispatcher;
